import { ChainId } from '@pancakeswap/sdk'
// import BigNumber from 'bignumber.js/bignumber'
import BigNumber from 'bignumber.js'
import { BIG_TEN } from '~/utils/bigNumber'
import {detectFeatureToggles} from "./featureToggles";

BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
})

export const BSC_BLOCK_TIME = 15 // 3 bsc , 15 ropsten

export const BASE_BSC_SCAN_URLS = {
  [ChainId.BSCMAINNET]: 'https://bscscan.com',
  [ChainId.BSCTESTNET]: 'https://testnet.bscscan.com',
  [ChainId.ROPSTEN] : 'https://ropsten.etherscan.io',
  [ChainId.FANTOM_TESTNET] : 'https://testnet.ftmscan.com/',
  [ChainId.MAINNET] : 'https://testnet.ftmscan.com/'
}


export const REWARD_PER_SEC = 4
export const SEC_IN_YEAR = 60 * 60 * 24 * 365
export const REWARD_PER_YEAR = REWARD_PER_SEC * SEC_IN_YEAR

// CAKE_PER_BLOCK details
// 40 CAKE is minted per block
// 20 CAKE per block is sent to Burn pool (A farm just for burning cake)
// 10 CAKE per block goes to CAKE syrup pool
// 9 CAKE per block goes to Yield farms and lottery
// CAKE_PER_BLOCK in config/index.ts = 40 as we only change the amount sent to the burn pool which is effectively a farm.
// CAKE/Block in src/views/Home/components/CakeDataRow.tsx = 15 (40 - Amount sent to burn pool)
export const CAKE_PER_BLOCK = 15 // 40
export const BLOCKS_PER_YEAR = (60 / BSC_BLOCK_TIME) * 60 * 24 * 365 // 10512000
export const CAKE_PER_YEAR = CAKE_PER_BLOCK * BLOCKS_PER_YEAR
export const BASE_URL = 'https://shimmersea.finance'
export const BASE_ADD_LIQUIDITY_URL = `${BASE_URL}/add`
export const BASE_BSC_SCAN_URL = BASE_BSC_SCAN_URLS[ChainId.FANTOM_TESTNET]
export const DEFAULT_TOKEN_DECIMAL = BIG_TEN.pow(18)
export const DEFAULT_GAS_LIMIT = 200000
export const AUCTION_BIDDERS_TO_FETCH = 500
export const RECLAIM_AUCTIONS_TO_FETCH = 500
export const AUCTION_WHITELISTED_BIDDERS_TO_FETCH = 500
export const IPFS_GATEWAY = 'https://ipfs.io/ipfs'
// In reality its 10000 because of fast refresh, a bit less here to cover for possible long request times
export const PANCAKE_BUNNIES_UPDATE_FREQUENCY = 8000

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'

export const featureToggles = detectFeatureToggles();

export const NFT_WHITELIST_SERVICE_URL = 'https://api.shimmersea.finance'
// export const NFT_WHITELIST_SERVICE_URL = 'http://localhost:3000'

export const NFT_WHITELIST_SERVICE_CAMPAIGN = 1
export const NFT_IMAGE_URL ='https://assets.shimmersea.finance/'
export const TOKEN_IMAGE_URL ='https://images.swapline.com'
export const WHITEPAPER_URL ='https://whitepaper.shimmersea.finance'
export const MEDIUM_DISCLAIMER_URL = "https://medium.com/@shimmerseadefi"
// export const API_URL = "https://test-api.swapline.com/api/v1"
export const API_URL = import.meta.env.VITE_API

// export const FAIRLAUNCH_URL = 'https://graph-qs.tanglesea.com/subgraphs/name/shimmersea/fairlaunch'
// export const TREAUSURY_INFO_URL = 'https://graph-qs.tanglesea.com/subgraphs/name/shimmersea/treasury'



export const DAO_ADDRESS = {
  [ChainId.FANTOM_TESTNET] : '0xC0E9c5dfd86F7b42d671Cc4DC070b0E3ef0a538B',
  [ChainId.STARDUST_TEST] : '0xC0E9c5dfd86F7b42d671Cc4DC070b0E3ef0a538B'
}

// export const FAIRLAUNCH_INITIAL_MINT = 1000000

export const DAO = '0xC0E9c5dfd86F7b42d671Cc4DC070b0E3ef0a538B'

export const BOOSTER_GO_LIVE = '2022-10-31 10:00:00 AM' // date and time for the booster go live
